import React, { useContext, useEffect, useState } from "react";


// ----> API URLS
import { urls } from "../../api-urls/api-urls";

// GLOBAL FUNCTION IMPORTATIONS
import { renderDate, renderSteps } from "../../global-functions/global-functions";

// COMPONENTS IMPORTATION
import { NavBarComp } from "../../components/navbar-comp/NavBarComp";
import { LoadingComp } from "../../components/loading-comp/LoadingComp";
import { UserContext } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";

export const DashBoardCustomer = () => {

  // USER CONTEXT
  const { user } = useContext(UserContext);

  // GET the useNavigate
  const navigate = useNavigate();



  // LANGUAGE
  const language = localStorage.getItem("language") || window.navigator.language.slice(0, 2);

  // GET the token
  const token = localStorage.getItem("token");


  // state definition
  const [dataServ, setDataServ] = useState([]);
  const [controller, setController] = useState(null); // estado para cancelar la peticion al servidor
  const [state, setState] = useState({ isLoading: false });

  // destructuring data server
  const { serviceCall } = dataServ && dataServ;



  // funcion para traer la data del servidor
  const fetchDataServer = async () => {
    const END_POINT = `${urls.serviceCallList}/${user.codCliente}`;

    const abortController = new AbortController();

    try {
      setState((val) => ({ ...val, isLoading: true }));
      const response = await fetch(END_POINT, {
        headers: {
          "Authorization": token
        },
        signal: abortController.signal
      });

      const data = await response.json();

      if (response.status === 200) {
        setDataServ(data);
      }

      setState((val) => ({ ...val, isLoading: false }));

    } catch (error) {
      console.log(error);
    }
  };



  // useEffect para traer la data del servidor
  useEffect(() => {

    fetchDataServer();

    return () => {
      if (controller) {
        controller.abort();
      }
    };

  }, []);



  return (
    <>
      {/* {
        errorHandling.error && (
          <div className="internal-error-notification">
            <strong style={{ color: 'var(--first-color)' }}>{errorHandling.msg}</strong>
          </div>
        )
      } */}
      <NavBarComp />
      {
        state.isLoading && (<LoadingComp />)
      }
      <div className="container">
        <h3 style={{ textDecoration: 'underline' }}>Casos Abiertos</h3>
        <h4 className="mt-2">Mantenimientos Correctivos</h4>
        <hr />
        {/* CARDS FOR PREVENTIVE MAINTENANCE */}
        <div className="d-flex-card-container">
          {
            serviceCall && serviceCall.map(call => (
              <div key={call.CodServicio} className="card">
                {/* DISPLAY ID CALL */}
                <div className="p-1">
                  <strong>ID</strong>
                  <span className="ml-1 fake-link">{call.CodServicio}</span>
                </div>
                {/* NOMBRE DEL CLIENTE */}
                <div className="p-1">
                  <strong>Cliente</strong>
                  <span className="ml-1 fake-link">{call.NomCliente}</span>
                </div>
                {/* NOMBRE DEL EQUIPO */}
                <div className="p-1">
                  <strong>Equipo</strong>
                  <span className="ml-1 fake-link">{call.NomTipEquipo}</span>
                </div>
                {/* ETAPA */}
                <div className="p-1">
                  <strong>Etapa</strong>
                  <span className="ml-1">{renderSteps(call.IdEtapa, language)}</span>
                </div>
                {/* EL PROBLEMA QUE EL CLIENTE INGRESO */}
                <div className="p-1">
                  <strong>Falla</strong>
                  <span style={{ textTransform: 'capitalize' }} className="ml-1">{call.Problema}</span>
                </div>
                {/* FECHA DE APERTURA */}
                <div className="p-1">
                  <strong>Fecha de apertura</strong>
                  <span style={{ textDecoration: 'underline', color: 'blue' }} className="ml-1">{renderDate(call.FecIngreso, language)}</span>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </>
  );
};